import { AngularComboItem } from "angular_library/models/angular-combo-item";

export class AngularCombo {
    name: string = "";
    classe: string="form-control";
    ListaValori: AngularComboItem[];
    disabled:boolean;
    value :string;
     constructor(){
        this.ListaValori = new Array<AngularComboItem>();
    }
}


// WEBPACK FOOTER //
// ./src/angular_library/models/angular-combo.ts